<template>

    <v-app
    :class="( (account.loggedIn) || $router.currentRoute.name === 'landing'  || $router.currentRoute.name === 'login'   ?'':' corchete-fondo fondo_login' ) 
    " 
    :style="(account.loggedIn) || $router.currentRoute.name === 'login'   ? { 'background-color': '#FFF' }: '' 
    "
    >
        <!-- APP TOP BAR   -->
        <app-bar v-if="account.loggedIn && $router.currentRoute.name !== 'documents_validate'"></app-bar>

        <!-- LEFT SIDE MENU   -->
        <navigation-drawer v-if="account.loggedIn && $router.currentRoute.name !== 'documents_validate'"></navigation-drawer>

        <!-- <BottomNavigation v-if="account.loggedIn"></BottomNavigation> -->
        <v-main class="bg_main" :style="($router.currentRoute.name === 'portfolio' || $router.currentRoute.name == 'orders_details' || $router.currentRoute.name == 'orders') ? 'background-color:#f6f1eb !important' : ''  " >
            <v-container fluid  :style="($router.currentRoute.name === 'landing' || $router.currentRoute.name == 'register')   ? {padding:'0 !important',height:'100%'} : ''  || ($router.currentRoute.name == 'register' ? { height:'100%'} : '' )"
                :class="$router.currentRoute.name == 'login' ? 'login-aux': '' " >
                <alert></alert>
                <loading></loading>
                <router-view />
            </v-container>
        </v-main>

        <AccountVerification v-if="account.user && account.user.confirmado != 1">
        </AccountVerification>

        <!-- <v-footer app>

        </v-footer> -->

    </v-app>
</template>

<script>

import AppBar from './components/AppBar'
import NavigationDrawer from './components/NavigationDrawer'
import Alert from './components/Alert'
import Loading from './components/Loading'
// import BottomNavigation from "./components/BottomNavigation";
import AccountVerification from "./components/AccountVerification";
import router from "../router";

import {mapActions, mapState} from 'vuex'

export default {
    name: 'App',
    computed: {
        ...mapState({account: state => state.account, alertsStore: state => state.alerts})
    },

    components: {
        AppBar, NavigationDrawer, Alert, Loading , AccountVerification
    },

    methods: {
        ...mapActions('account', ['checkLogin']),
    },

    created() {
        this.checkLogin();
        window.set_vue_form_value = (fieldName, newValue) => {
            this.$root.$emit(`form_value_${fieldName}`, newValue)
        }
    },

    watch: {
        '$store.state.alerts.redirect'() {
            if (this.alertsStore.redirect !== null){
                if (this.alertsStore.redirect.validator === undefined){
                    router.push(this.alertsStore.redirect)
                }else if (router.currentRoute.name === this.alertsStore.redirect.validator) {
                    router.push(this.alertsStore.redirect)
                }

                this.alertsStore.redirect = null
            }
        }
    },

    data: () => ({
        drawer: true,
        isMobile: false,
    }),
};
</script>

<style>

@media only screen and (max-width: 770px) {
    .corchete-fondo{
        background-size: 90% 120% !important;
        background-position : center top  !important;
        resize:  vertical !important;
        background-color: #fff5d3 !important;
        background-repeat: no-repeat, repeat !important;
    }   

    .login-aux{
        background-color: #FFF;
        padding-top: 0;
    }
}
</style>
